const DEFAULT_STATE = {
    isFetching: false,
    data: [],
    isFetchingPersonalInfo: false,
    personalInfo: {},
};

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case 'RelationshipActions.ON_BEFORE_GET': {
            return {
                ...state,
                isFetching: true,
            };
        }

        case 'RelationshipActions.ON_GET': {
            return {
                ...state,
                isFetching: false,
                data: action.result,
            };
        }

        case 'RelationshipActions.ON_RESET_RELATIONSHIP': {
            return DEFAULT_STATE;
        }

        case 'RelationshipActions.ON_BEFORE_GETPERSONALDETAILS': {
            return {
                ...state,
                isFetchingPersonalDetails: true,
            };
        }

        case 'RelationshipActions.ON_GETPERSONALDETAILS': {
            return {
                ...state,
                isFetchingPersonalDetails: false,
                personalInfo: action.result,
            };
        }

        default:
            return state;
    }
};
